import {
  MICHELIN_RECOMMENDATIONS_REQUESTED,
  MICHELIN_RECOMMENDATIONS_RECEIVED,
  MICHELIN_RECOMMENDATIONS_FAILED,
  MICHELIN_RECOMMENDATIONS_RESET,
  HOTEL_CONTENT_REQUESTED,
  HOTEL_CONTENT_RECEIVED,
  HOTEL_CONTENT_FAILED,
} from '../helpers/constants/actionsConstants';

import type { MichelinRecommendationsAction } from '../actions/michelin-actions';
import type { MichelinRecommendationsState } from '../selectors/michelinTypes';

const initialState: MichelinRecommendationsState = {
  status: 'idle',
  recommendation: null,
  hotelContent: null,
  hotelContentStatus: 'idle',
};

export const reducer = (
  state: MichelinRecommendationsState = initialState,
  action: MichelinRecommendationsAction,
): MichelinRecommendationsState => {
  switch (action.type) {
    case MICHELIN_RECOMMENDATIONS_REQUESTED:
      return {
        ...state,
        status: 'loading',
        recommendation: null,
        hotelContent: null,
        hotelContentStatus: 'idle',
      };

    case MICHELIN_RECOMMENDATIONS_RECEIVED:
      return {
        ...state,
        status: 'complete',
        recommendation: action.payload.recommendation,
      };

    case MICHELIN_RECOMMENDATIONS_FAILED:
      return {
        ...state,
        status: 'error',
        recommendation: null,
        hotelContent: null,
        hotelContentStatus: 'idle',
      };

    case MICHELIN_RECOMMENDATIONS_RESET:
      return initialState;

    case HOTEL_CONTENT_REQUESTED:
      return {
        ...state,
        hotelContentStatus: 'loading',
        hotelContent: null,
      };

    case HOTEL_CONTENT_RECEIVED:
      return {
        ...state,
        hotelContentStatus: 'complete',
        hotelContent: action.payload.hotelContent,
      };

    case HOTEL_CONTENT_FAILED:
      return {
        ...state,
        hotelContentStatus: 'error',
        hotelContent: null,
      };

    default:
      return state;
  }
};

export default reducer;
